import React, { useMemo, useState } from 'react'

import { FilterActions, ReservationsFilters as ReservationsListFilter, useFiltersContext } from '@/context'

import { ApplyButton, ClearButton, FilterOption } from '../components'

type keys = keyof ReservationsListFilter

type Props = {
  multiSelect?: boolean
  onClose: () => void
}
const ReservationsFilters = ({ multiSelect = false, onClose }: Props) => {
  const [{ reservationsFilters }, FilterDispatch] = useFiltersContext()
  const [filterOptions, setFilterOptions] = useState(reservationsFilters)

  const onSelectFilter = (selectedOption: { [key in keys]: boolean }) => {
    if (multiSelect) {
      setFilterOptions((prev) => ({ ...prev, ...selectedOption }))
    } else {
      setFilterOptions({ ...selectedOption })
    }
  }

  const onApply = () => {
    FilterDispatch(FilterActions.setFilters({ filterName: 'reservations', filters: filterOptions }))
    FilterDispatch(FilterActions.clearReservationMoveOutRange())
    onClose()
  }

  const onClear = () => {
    FilterDispatch(FilterActions.clearFilters({ filterName: 'reservations' }))
    FilterDispatch(FilterActions.clearReservationMoveOutRange())
    onClose()
  }

  const showClearButton = useMemo(() => Object.keys(filterOptions).find((key) => !!filterOptions[key]), [filterOptions])

  return (
    <>
      <FilterOption
        label="Move In Today"
        name="moveInToday"
        onSelect={onSelectFilter}
        value={!!filterOptions['moveInToday']}
      />
      <FilterOption
        label="Move In 48 hours"
        name="moveIn48Hrs"
        onSelect={onSelectFilter}
        value={!!filterOptions['moveIn48Hrs']}
      />
      <FilterOption
        label="Move In 3 days"
        name="moveIn3days"
        onSelect={onSelectFilter}
        value={!!filterOptions['moveIn3days']}
      />
      <FilterOption
        label="Move In 7 days"
        name="moveIn7Days"
        onSelect={onSelectFilter}
        value={!!filterOptions['moveIn7Days']}
      />
      <FilterOption
        label="Current"
        name="currentReservations"
        onSelect={onSelectFilter}
        value={!!filterOptions['currentReservations']}
      />
      <FilterOption
        label="Flight X"
        name="flightxInProgress"
        onSelect={onSelectFilter}
        value={!!filterOptions['flightxInProgress']}
      />
      <FilterOption label="Lexit" name="lexit" onSelect={onSelectFilter} value={!!filterOptions['lexit']} />
      <FilterOption label="Approved" name="approved" onSelect={onSelectFilter} value={!!filterOptions['approved']} />
      <FilterOption label="Autopilot" name="autopilot" onSelect={onSelectFilter} value={!!filterOptions['autopilot']} />
      {showClearButton && <ClearButton onClick={onClear} />}
      <ApplyButton onClick={onApply} />
    </>
  )
}

export default ReservationsFilters
